
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/compliassist",
      function () {
        return require("private-next-pages/compliance/compliassist/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/compliassist"])
      });
    }
  